<template lang="pug">
.d-flex
  .flex-grow-1
    filter-suppliers.mr-2(:filter.sync="nameFilter" filterKey="name")
    filter-stock-transfer-type.mr-2(:filter.sync="typeFilter")
    filter-suppliers.mr-2(:filter.sync="branchFilter" filterKey="branch")
    filter-reference.mr-2(:filter.sync="referenceFilter")
    filter-stock-transfer-request-statuses.mr-2(:filter.sync="requestStatusFilter")
    filter-inventory-statuses.mr-2(:filter.sync="inventoryStatusFilter")
  v-btn.button-sm.underline.px-0(text :disabled="allFilters.length === 0" @click="resetFilters") Reset filters
</template>

<script>
import FilterSuppliers from '@/components/clinic/purchasehub/filters/FilterSuppliers.vue'
import FilterReference from '@/components/clinic/purchasehub/filters/FilterReference.vue'
import FilterInventoryStatuses from '@/components/clinic/purchasehub/filters/FilterInventoryStatuses.vue'
import FilterStockTransferType from '@/components/clinic/purchasehub/filters/FilterStockTransferType.vue'
import FilterStockTransferRequestStatuses from '@/components/clinic/purchasehub/filters/FilterStockTransferRequestStatuses.vue'

export default {
  components: {
    FilterSuppliers, FilterReference, FilterInventoryStatuses, FilterStockTransferType, FilterStockTransferRequestStatuses
  },
  props: ['filters'],
  data: () => ({
    nameFilter: {},
    typeFilter: {},
    branchFilter: {},
    referenceFilter: {},
    requestStatusFilter: {},
    inventoryStatusFilter: {},
  }),
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    }
  },
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) filters.push(this.nameFilter)
      if (this.typeFilter.key) filters.push(this.typeFilter)
      if (this.branchFilter.key) filters.push(this.branchFilter)
      if (this.referenceFilter.key) filters.push(this.referenceFilter)
      if (this.requestStatusFilter.key) filters.push(this.requestStatusFilter)
      if (this.inventoryStatusFilter.key) filters.push(this.inventoryStatusFilter)
      return filters
    }
  },
  methods: {
    resetFilters () {
      this.nameFilter = {}
      this.typeFilter = {}
      this.branchFilter = {}
      this.referenceFilter = {}
      this.requestStatusFilter = {}
      this.inventoryStatusFilter = {}
    },
  }
}
</script>
